export default "__VITE_ASSET__DT7tYI3T__"